module.exports = __webpack_public_path__ + "img/pexels-markus-spiske-3970330.1b2afdd2.jpg";